
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    navTitle: String,
    navTip: String,
  },
});
